import { createServerFn } from "@tanstack/react-start";

export const getAiChatState = createServerFn({ method: "POST" })
  .inputValidator((input: { anonId: string }) => input)
  .handler(async ({ data }) => {
    const { getAiChatStatus } = await import("./aiChat.server");
    return getAiChatStatus(data.anonId ?? "");
  });

export const askAiChatQuestion = createServerFn({ method: "POST" })
  .inputValidator(
    (input: {
      question: string;
      anonId: string;
      history?: { role: "user" | "assistant"; content: string }[];
      isClarification?: boolean;
      fromPath?: string;
    }) => input,
  )
  .handler(async ({ data }) => {
    const { askAiChat, AiChatError } = await import("./aiChat.server");
    try {
      return {
        ok: true as const,
        ...(await askAiChat({
          question: data.question ?? "",
          anonId: data.anonId ?? "",
          history: data.history ?? [],
          isClarification: data.isClarification ?? false,
          fromPath: data.fromPath ?? "",
        })),
      };

    } catch (error) {
      if (error instanceof AiChatError) {
        return {
          ok: false as const,
          status: error.status,
          message: error.message,
          sources: error.sources ?? [],
        };
      }
      console.error("AI chat failed", error);
      return { ok: false as const, status: 500, message: "Något gick fel. Försök igen.", sources: [] };
    }
  });

export const submitAiChatFeedback = createServerFn({ method: "POST" })
  .inputValidator(
    (input: {
      usageId?: string | null;
      anonId: string;
      question?: string;
      answerExcerpt?: string;
      rating: number;
      comment?: string;
      fromPath?: string;
    }) => input,
  )
  .handler(async ({ data }) => {
    const { saveAiChatFeedback, AiChatError } = await import("./aiChat.server");
    try {
      await saveAiChatFeedback({
        usageId: data.usageId ?? null,
        anonId: data.anonId ?? "",
        question: data.question ?? "",
        answerExcerpt: data.answerExcerpt ?? "",
        rating: data.rating,
        comment: data.comment ?? "",
        fromPath: data.fromPath ?? "",
      });
      return { ok: true as const };
    } catch (error) {
      if (error instanceof AiChatError) {
        return { ok: false as const, message: error.message };
      }
      console.error("AI chat feedback failed", error);
      return { ok: false as const, message: "Kunde inte spara din feedback. Försök igen." };
    }
  });
